import DocsPage from 'views/Docs/DocsPage'
export default DocsPage
